// Forked from ../Tooltip

import React, { Fragment, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

import Portal from '../Portal'

export default class ScreenReaderTip extends React.PureComponent {
    static propTypes = {
        /** Must be a single interactive element, such as a link or button */
        children: PropTypes.node.isRequired,

        /** The phrase to be read when the child has focus */
        content: PropTypes.node.isRequired,

        /** Id used to link the control with the audible tooltip */
        id: PropTypes.string
    }

    static defaultProps = {
        id: 'screen-reader-tip-component'
    }

    constructor(props) {
        super(props);
        this.triggerRef = React.createRef();

        this.state = {
            isActive: false
        };
    }

    activateTip = () => {
        if (!this.triggerRef.current.disabled) {
            this.setState({
                isActive: true
            });
        }
    }

    deactivateTip = () => {
        this.setState({
            isActive: false
        });
    }

    render() {
        const { children, content, id } = this.props;
        const { isActive } = this.state;

        return (
            <Fragment>
                {(Children.map(children, (child) => {
                    const childType = typeof child.type;
                    const newProps = {
                        "aria-describedby": isActive ? id : null,
                        onFocus: this.activateTip,
                        onBlur: this.deactivateTip
                    };

                    if (childType === 'string') {
                        newProps.ref = this.triggerRef;
                    }
                    else {
                        newProps.innerRef = this.triggerRef;
                    }

                    return cloneElement(child, newProps);
                }))}
                {isActive && (
                    <Portal>
                        <span className="rec-sr-only" role="tooltip" id={id}>
                            {content}
                        </span>
                    </Portal>
                )}
            </Fragment>
        );
    }
}